import { ThemeOptions } from "@material-ui/core";
import { createMuiTheme } from "@material-ui/core/styles";
export interface DynamicThemeModule {
    default: AlmeTheme;
}

export interface AlmeTheme {
    lightTheme: ThemeOptions;
    darkTheme: ThemeOptions;
}

export const defaultTheme = createMuiTheme();
export const defaultDarkTheme = createMuiTheme({ palette: { type: 'dark' } });

export const defaultAlmeTheme = {
    lightTheme: defaultTheme,
    darkTheme: defaultDarkTheme,
} as AlmeTheme;

export type AlmeThemeMode = 'light' | 'dark';